// Define the new options
$(function() {
	var accBtn = $('.pl_acc_header');
	if (accBtn) {
		$.each(accBtn, function() {
			$(this).on('click', function() {
				$.each(accBtn, function() {
					if ($(this).attr('aria-expanded') === 'true') {
						$(this).addClass('expanded');
					} else {
						$(this).removeClass('expanded');
					}
				});
			});
		});
	}
});
